import Api from './chart.api';
import { UserError } from 'utilities/ErrorHandlling/ErrorHandlling';

const chart = new Api('chart/', 'chart');
const chartSphere = new Api('chart/sphere/', 'chart');
const keyInsights = new Api('services/insights/', 'insights');
const channel = new Api('services/', 'account');

// --- getAttributionModalOptions action
export const getChartData = async props => {
  let apiData = {};

  try {
    let isBeta = false;
    if(props.isBeta !== undefined) {
      isBeta = props.isBeta;
      delete props['isBeta'];
    }
    if(isBeta) {
      apiData = await chartSphere.getChartData(props)
    } else {
      apiData = await chart.getChartData(props);
    }
    return apiData;
  } catch (error) {
    throw new UserError(error);
  }
};

// ----- GET statistic count
export const getKeyMetricsData = async props => {
  let apiData = {};

  try {
    apiData = await keyInsights.getKeyMetricsData(props);
    if (apiData && apiData.hasError) {
      return { loading: false, error: true };
    } else {
      return { loading: false, error: false, ...apiData };
    }
  } catch (error) {
    return { loading: false, error: true };
  }
};

export const getChannelList = async props => {
  let apiData = {};

  try {
    apiData = await channel.getChannelList(props);
    return apiData;
  } catch (error) {
    throw new UserError(error);
  }
};

